<template>
  <b-modal id="customer-gen-quotation-payments" ref="modal" title="Plan de Adeudos SEPA" hide-footer>

    <template v-if="sepa_account">
      <div class="row form-group">
        <div class="col-md-12">
          <h6>DATOS PAGADOR</h6>
        </div>

        <div class="col-md-3">
          <input type="text" v-model="sepa_account.name" class="form-control" id="sepa_name" readonly>
          <label for="sepa_name" class="wabident-info">Nombre</label>
        </div>

        <div class="col-md-3">
          <input type="text" v-model="sepa_account.nif" class="form-control" id="sepa_nif" readonly>
          <label for="sepa_nif" class="wabident-info">NIF</label>
        </div>

        <div class="col-md-3">
          <input type="text" v-model="sepa_account.iban" class="form-control" id="sepa_iban" readonly>
          <label for="sepa_iban" class="wabident-info">IBAN</label>
        </div>

        <div class="col-md-3">
          <input type="text" v-model="sepa_account.bic" class="form-control" id="sepa_bic" readonly>
          <label for="sepa_bic" class="wabident-info">BIC</label>
        </div>
      </div>

      <div class="row form-group">
        <!-- PAYMENT PLAN BASIC INFO-->
        <div class="col-md-12">
          <h6>PLAN DE PAGOS</h6>
        </div>
        <div class="col-md-3">
          <input type="number" class="form-control" v-model="plan.payment_plan.total_amount" id="total_amount"
            :readonly="has_payments">
          <label for="total_amount" class="wabident-info">Cantidad total</label>
        </div>
        <div class="col-md-3">
          <input @change="recomputePayments()" type="date" class="form-control"
            v-model="plan.payment_plan.first_payment_date" :readonly="has_payments" id="first_payment_date">
          <label for="sepa_iban" class="wabident-info">Fecha del primer pago</label>
        </div>
        <div class="col-md-6">
          <input type="text" class="form-control" v-model="plan.sepa_mandate_id" id="sepa_mandate_id" readonly>
          <label for="sepa_mandate_id" class="wabident-info">ID Mandato SEPA</label>
        </div>
      </div>

      <!-- PAYMENT PLAN TOOLS PANEL -->
      <div class="row form-group">
        <div class="col-md-12">
          <h6>ESQUEMA DE PAGOS</h6>
        </div>

        <div class="col-md-3">
          <input @change="recomputePayments()" type="number" class="form-control"
            v-model="plan.payment_plan.schema.first_payment" id="first_payment" :readonly="has_payments">
          <label for="first_payment" class="wabident-info">Primer Pago (€)</label>
        </div>

        <div class="col-md-3">
          <input @change="recomputePayments()" type="number" class="form-control"
            v-model="plan.payment_plan.schema.second_payment" :readonly="has_payments" id="second_payment">
          <label for="second_payment" class="wabident-info">Segundo Pago (€)</label>
        </div>

        <div class="col-md-3">
          <input type="number" @change="recomputePayments()" class="form-control"
            v-model="plan.payment_plan.schema.total_installments" :readonly="has_payments" id="total_installments">
          <label for="total_installments" class="wabident-info">Mensualidades</label>
        </div>

        <div class="col-md-3">
          <input @change="recomputePayments()" type="number" class="form-control"
            v-model="plan.payment_plan.schema.last_payment" id="last_payment" :readonly="has_payments">
          <label for="last_payment" class="wabident-info">Último Pago (€)</label>
        </div>
      </div>

      <!-- PAYMENTS LIST EDITOR -->
      <div class="row form-group">
        <div class="col-md-12">
          <h6>LISTADO DE PAGOS</h6>
        </div>
        <div class="col-md-12">
          <table class="table table-search-results">
            <thead>
              <tr>
                <th>#</th>
                <th>CONCEPTO</th>
                <th class="text-center">FECHA PAGO</th>
                <th class="text-center">CUOTAS</th>
                <th class="text-right">IMPORTE</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="payment in payments" :key="payment.id">
                <td>{{ payment.order }}</td>
                <td>{{ payment.notes }}</td>
                <td class="text-center">{{ payment.pretty_date }}</td>
                <td class="text-center">{{ payment.quantity }}</td>
                <td class="text-right">{{ payment.pretty_amount }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </template>

    <div v-else class="row form-group">
      <div class="col">
        <b-alert variant="danger" show>El Paciente no tiene activa ninguna cuenta SEPA. Por favor añade una en la Ficha
          de Paciente</b-alert>
      </div>
    </div>

    <div class="row form-group d-flex align-items-center justify-content-around">
      <button v-if="has_payments" type="button" class="btn btn-wabident red" @click="onDeletePayments"
        :disabled="is_loading">
        Borrar Pagos
      </button>

      <button type="button" class="btn btn-wabident" @click="onCancel">
        Cerrar
      </button>

      <button v-if="!has_payments" type="button" class="btn btn-wabident green" @click="onSave"
        :disabled="!is_valid || is_loading">
        Generar&nbsp;Plan
      </button>
    </div>

  </b-modal>
</template>

<script>
export default {
  props: ['customer', 'clinic'],
  data() {
    return {
      quotation: null,
      plan: {
        payments: [],
        payment_plan: {
          first_payment_date: null,
          total_amount: 0,
          payments: [],
          schema: {
            first_payment: 0,
            second_payment: 0,
            total_installments: 12,
            last_payment: 0,
          }
        }
      },
      is_loading: false,
    }
  },
  computed: {
    payments() {
      return this.plan.payment_plan.payments;
    },
    has_payments() {
      return this.plan && (this.plan.payments.length > 0);
    },
    is_valid() {
      return true;
    },
    sepa_account() {
      return this.customer.sepa_account;
    },
    ...mapGetters(['msgwindow', 'errorwindow'])
  },
  methods: {
    show(quotation) {
      this.quotation = quotation;
      this.loadPlan();
      this.$refs.modal.show();
    },
    onCancel() {
      this.$emit('submit');
      this.$refs.modal.hide();
    },
    onSave() {
      if (!this.is_loading) {
        const params = {
          payment_plan: this.plan.payment_plan,
        };
        this.is_loading = true;

        axios.post(`/quotation/${this.quotation.id}/payment_plan`, params).then((response) => {
          this.errorwindow.show('Pagos Creados', '<p>Se han creado los Pagos de este plan, consulta la sección <b>Facturación</b>' +
            '<p>Se ha creado el <b>MANDATO SEPA</b> para el Paciente en la sección <b>Documentos</b>.' +
            '<b>Recuerda que el paciente debe firmar el Mandado.</b>', 'Aceptar');
        }).catch((error) => {
          this.msgwindow.error('Error generando plan de pagos');
        }).then(() => {
          this.is_loading = false;
          this.$emit('submit');
          this.$refs.modal.hide();
        });
      }
    },
    onDeletePayments() {
      const msg = '<b>Esto borrará todos los Pagos de este Plan pendientes de crear Remesa.</b><br>¿Seguro?'
      this.errorwindow.show('Confirmación', msg, 'Borrar pagos', 'Cancelar', () => {
        this.doDeletePayments();
      });
    },
    doDeletePayments() {
      if (!this.is_loading) {
        const params = {
          '_method': 'delete',
        };
        this.is_loading = true;

        axios.post(`/quotation/${this.quotation.id}/payment_plan`, params).then((response) => {
          this.msgwindow.success('Pagos Borrados');
        }).catch((error) => {
          this.msgwindow.error('Error borrando Pagos');
        }).then(() => {
          this.is_loading = false;
          this.$emit('submit');
          this.$refs.modal.hide();
        });
      }
    },
    loadPlan() {
      axios.get(`/quotation/${this.quotation.id}/payment_plan`)
        .then((response) => {
          this.plan = response.data;
          this.recomputePayments();
        }).catch((error) => {
          console.log('Error');
        });
    },
    recomputePayments() {
      if (this.has_payments) {
        return;
      }

      let order = 1;
      let pplan = this.plan.payment_plan;
      let date = moment(pplan.first_payment_date);

      pplan.payments = [];

      let remaining_amount = pplan.total_amount;
      let schema = pplan.schema;

      // FIST PAYMENT
      if (schema.first_payment > 0) {
        pplan.payments.push({
          order: order,
          notes: this.quotation.notes + ' - PRIMER PAGO',
          date: date.format('YYYY-MM-DD'),
          pretty_date: date.format('DD/MM/YYYY'),
          status: 'Pendiente',
          amount: schema.first_payment,
          quantity: 1,
          pretty_amount: WabiDent.fmtMoney(schema.first_payment),
        });

        date = date.add(1, 'months');
        order += 1;
        remaining_amount -= schema.first_payment;
      }

      // SECOND PAYMENT
      if (schema.second_payment > 0) {
        pplan.payments.push({
          order: order,
          notes: this.quotation.notes + ' - SEGUNDO PAGO',
          date: date.format('YYYY-MM-DD'),
          pretty_date: date.format('DD/MM/YYYY'),
          amount: schema.second_payment,
          quantity: 1,
          pretty_amount: WabiDent.fmtMoney(schema.second_payment),
        });

        date = date.add(1, 'months');
        remaining_amount -= schema.second_payment;
      }

      // INSTALLMENTS
      if (schema.last_payment > 0) {
        remaining_amount -= schema.last_payment;
      }

      if (schema.total_installments > 0) {
        const installment_amount = (remaining_amount / schema.total_installments).toFixed(2);
        pplan.payments.push({
          order: order,
          notes: this.quotation.notes + ' - MENSUALIDAD ',
          date: date.format('YYYY-MM-DD'),
          pretty_date: date.format('DD/MM/YYYY'),
          amount: installment_amount,
          quantity: schema.total_installments,
          pretty_amount: WabiDent.fmtMoney(installment_amount),
        });

        date = date.add(schema.total_installments, 'months');
        order += 1;
      }

      // FINAL PAYMENT
      if (schema.last_payment > 0) {
        pplan.payments.push({
          order: order,
          notes: this.quotation.notes + ' - PAGO FINAL',
          date: date.format('YYYY-MM-DD'),
          pretty_date: date.format('DD/MM/YYYY'),
          amount: schema.last_payment,
          pretty_amount: WabiDent.fmtMoney(schema.last_payment),
          quantity: 1,
        });


        date = date.add(1, 'months');
        order += 1;
      }

    },
  }
}
</script>

<style lang="scss">
#customer-gen-quotation-payments {
  .modal-dialog {
    max-width: 65vw;
  }

  .table tr:nth-child(2n) {
    background-color: var(--theme-highlight);
  }
}
</style>
